import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const onvioLinearProgressBarCss = ":host{display:block}.onvio-linear-blue{background-color:#005da2;height:4px}.OV-progress-background{align-items:flex-start;background:#ededed;border-radius:4px;flex-direction:column;gap:8px;padding-right:0;width:150px}.OV-center{display:flex;justify-content:center;text-align:center}.OV-progress-label{color:#404040;font-family:\"Source Sans Pro\", arial, sans-serif;font-feature-settings:\"clig\" off, \"liga\" off;font-size:14px;font-style:normal;font-weight:400;line-height:20px;text-align:right}";

const OnvioLinearProgressBar$1 = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.progress = undefined;
    this.complete = undefined;
  }
  updateProgress(value) {
    return (value > -1 && (h("div", { class: "OV-center" }, h("label", { class: "OV-progress-label" }, this.progress, "% ", this.complete))));
  }
  render() {
    return (h(Host, null, h("slot", null, this.updateProgress(this.progress), h("div", { class: "OV-center" }, h("div", { class: "OV-progress-background" }, h("div", { class: "onvio-linear-blue", style: { width: `${this.progress}%` } }))))));
  }
  static get style() { return onvioLinearProgressBarCss; }
}, [1, "onvio-linear-progress-bar", {
    "progress": [2],
    "complete": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["onvio-linear-progress-bar"];
  components.forEach(tagName => { switch (tagName) {
    case "onvio-linear-progress-bar":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, OnvioLinearProgressBar$1);
      }
      break;
  } });
}

const OnvioLinearProgressBar = OnvioLinearProgressBar$1;
const defineCustomElement = defineCustomElement$1;

export { OnvioLinearProgressBar, defineCustomElement };

